import axios from 'axios';
import cookieReader from 'js-cookie';

import { ensureEnv } from './env';
import { getMainApiUrl } from './url';
import { attachDiagnostics } from './diagnostics/diagnosticAxiosInterceptor';

const getSecurityTokenName = (): string =>
  ensureEnv('VITE_SECURITY_TOKEN_NAME');
const getTokenDomain = (): string => ensureEnv('VITE_TOKEN_DOMAIN');
const getApiDfTokenName = (): string => ensureEnv('VITE_API_DF_TOKEN_NAME');

export const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const { status, data } = error.response || {};
    return Promise.reject({
      status,
      ...data,
    });
  },
);

attachDiagnostics(axiosInstance, 'platform-axios');

export const api = axios.create({
  baseURL: '',
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  config.baseURL = getMainApiUrl();

  const token = cookieReader.get(getSecurityTokenName()) || '';
  if (token) {
    config.headers[getApiDfTokenName()] = token;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const { status, data } = error.response || {};

    if (status === 401) {
      cookieReader.remove(getSecurityTokenName(), {
        domain: getTokenDomain(),
      });
    }

    if (typeof data === 'string') {
      return Promise.reject({
        status,
        message: data,
      });
    }

    return Promise.reject({
      status,
      ...data,
    });
  },
);

attachDiagnostics(api, 'platform-api');
